import { agentNotesColumns } from "./renewalsColumns";
import { SearchableTable } from "../shared/table/SearchableTable";

const AgentNotes = ({ notes, loading }) => {
  return (
    <>
      <SearchableTable
        keyColumn="Id"
        dataSource={notes}
        columns={agentNotesColumns()}
        loading={loading}
        size="small"
        rowKey={(n) => n.Id}
        hideClearFiltersButtons={true}
      />
    </>
  );
};

export default AgentNotes;
